<template>
  <div class="inputBoxWrap">
    <label>{{item.label}}<br/>

      <suggestions
        v-model="value"
        :options="options"
        :onInputChange="onInputChange"
        :onItemSelected="onSearchItemSelected"
      >

        <div slot="item" slot-scope="props" class="single-item">
          <span class="name">{{props.item.value}}</span>
        </div>
      </suggestions>
      <p class="errorMsg" v-if="statusVuex[refs].ShowError">{{errorMsg}}</p>
    </label>


  </div>
</template>

<script>
  import 'v-suggestions/dist/v-suggestions.css';
  import DataForInput from '@/store/Form/longFormOptions';
  import {mapState} from 'vuex';

  export default {
    name: "vmSelectDadata",
    props:{
      refs: {
        type: String,
        default: 'null'
      },
    },
    data() {
      return {
        query:'',
        selectedCountry: null,
        selectedSearchItem: null,
        options: {
          placeholder: DataForInput[this.refs].placeholder,
        },
        item: DataForInput[this.refs],
      }
    },
    computed:{
      ...mapState({
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
      }),
      value:{
        get(){
          return this.valueVuex[this.refs]
        },
        set(value){
          let utiputi = {
            target:this.refs,
            value: value
          };
          this.$store.dispatch('saveSendData',utiputi);
        }
      },
      errorMsg(){
        return this.statusVuex[this.refs].msg;
      },
    },
    components: {
      suggestions:()=>import('v-suggestions')
    },
    methods:{
      onInputChange (query) {
        if (query.trim().length === 0) {
          return null;
        }
        // return the matching countries as an array

        if (this.refs === 'WORK_TITLE') {
          return new Promise(resolve => {
            this.$myApi.suggestResultGigData(query, 5)
                .then(resp => {
                  let suggestions = resp.data.suggestions;
                  let result = (Array.isArray(suggestions) && suggestions.length) ? suggestions : [];
                  resolve(this.suggestions = result);
                })
                .catch(err => {
                  console.error("Ошибка при запросе suggestResultGigData", err);
                });
          });
        } else {
          if (this.refs === 'PASSPORT_DEP' && this.valueVuex.PASSPORT_DEP_CODE.length > 0) {
            query = this.valueVuex.PASSPORT_DEP_CODE;
          }
          return new Promise(resolve => {
            this.$myApi.suggestResult(
                this.refs,
                {'value': query, 'type': this.refs}
            ).then(resp => {
              let dadataSuggest = resp.data.result.suggestions;
              let result = (Array.isArray(dadataSuggest) && dadataSuggest.length) ? dadataSuggest : [];
              resolve(result);
            });
          });
        }
      },
      onSearchItemSelected (item) {
        console.log(item)
        this.$palantir.trackInputBlur(this.refs, item.value);
        this.selectedSearchItem = item;
        this.query = item.value;
        this.$store.dispatch('saveSendData',{
          target: this.refs,
          value: item.value,
          jsonSuggestion:item
        });
        this.namesGenderToStorage(item);
        this.dadataAddressToStorage(item);
      },
      dadataAddressToStorage(item) {
        if (this.refs.indexOf('_ADDRESS') > 0) {
          this.$store.dispatch('saveSendData', {
            target: this.refs + '_DADATA',
            value: item,
          });
        }
      },
      namesGenderToStorage(item) {
        if (this.refs.indexOf('NAME') > 0) {
          if (item.data.gender === 'MALE') {
            this.$store.dispatch('saveSendData', {
              target: 'GENDER',
              value: 'M',
            });
          } else if (item.data.gender === 'FEMALE') {
            this.$store.dispatch('saveSendData', {
              target: 'GENDER',
              value: 'F',
            });
          } else {
            return false
          }
        }
      }

    },

  }
</script>

<style scoped>

  .inputBoxWrap{background: #F6F8F7;padding: 3vw 3vw 2vw;border-radius: 1px;}
  .inputBoxWrap label{display: block;color:#869A95;font-size:  4vw;}
  /deep/input{display: block;color:#222721;font-size: 5vw;padding: 1.6vw 0;background: transparent;border: 0;width: 100%;}
  .inputBoxWrap p{display: block;}
  /deep/.v-suggestions .items .item.is-active{background: #43AC35;color:white}
  /deep/.v-suggestions .items .item:hover{color:#0D5A44;}

  @media screen and (min-width: 760px) {
    .inputBoxWrap{margin-bottom: 0.6vw;padding: 1.5vw 1.1vw 1vw;}
    .inputBoxWrap label{font-size: 1.1vw;}
    /deep/input{font-size: 1.3vw;padding: 0.2vw 0;}
    .inputBoxWrap p{}
  }
  @media screen and (min-width: 1140px) {
    .inputBoxWrap{padding: 17px 13px 11px;margin-bottom: 7px;}
    .inputBoxWrap label{font-size:  12px;}
    /deep/input{font-size: 14px;padding: 2px 0;}
    .inputBoxWrap p{}
  }
</style>
